import { ItemData } from '../types'

export const sortResults = (data: ItemData[]): ItemData[] =>
  data.sort((a, b) => {
    const aDisplayPriority = a.displayPriority ?? 1
    const bDisplayPriority = b.displayPriority ?? 1

    if (aDisplayPriority < bDisplayPriority) {
      return -1
    }

    if (aDisplayPriority > bDisplayPriority) {
      return 1
    }

    if (a.isPreferred && !b.isPreferred) {
      return -1
    }

    if (!a.isPreferred && b.isPreferred) {
      return 1
    }

    if (a.isVirtualCareOnly && !b.isVirtualCareOnly) {
      return -1
    }

    if (b.isVirtualCareOnly && !a.isVirtualCareOnly) {
      return 1
    }

    if (a.distance === b.distance) {
      if (a.fullName && b.fullName) {
        return a.fullName.localeCompare(b.fullName)
      }

      return a.practiceName.localeCompare(b.practiceName)
    }

    return a.distance - b.distance
  })
